import { CommonStyles } from '../../../../../../../../../../../../../../../../../../ui-library/styles/common.styles'

export const ManualAddressItemStyles = {
  container: 'px-3 py-2 bg-white150 rounded',
  item: CommonStyles.anchorLink
}
